<template lang="html">
  <div class="cst">
    <img class="banner" :src="`${pagebase}/static/img/cst/banner.png`" alt="">
    <img class="modImg" :src="`${pagebase}/static/img/cst/modNo1.png`" alt="">
    <img class="modImg" :src="`${pagebase}/static/img/cst/modNo2.png`" alt="">
    <img class="modImg" :src="`${pagebase}/static/img/cst/modNo3.png`" alt="">
    <img class="modImg" :src="`${pagebase}/static/img/cst/modNo4.png`" alt="">
    <img class="modImg" :src="`${pagebase}/static/img/cst/modNo5.png`" alt="">
    <img class="modImg" :src="`${pagebase}/static/img/cst/modNo6.png`" alt="">
    <img class="modImg" :src="`${pagebase}/static/img/cst/modNo7.png`" alt="">
    <img class="modImg" :src="`${pagebase}/static/img/cst/modNo8.png`" alt="">
    <img class="modImg" :src="`${pagebase}/static/img/cst/modNo9.png`" alt="">
    <img class="modImg" :src="`${pagebase}/static/img/cst/modNo10.png`" alt="">
    <img class="modImg" :src="`${pagebase}/static/img/cst/modNo11.png`" alt="">
    <img class="modImg" :src="`${pagebase}/static/img/cst/modNo12.png`" alt="">
    <img class="modImg" :src="`${pagebase}/static/img/cst/modNo13.png`" alt="">
    
    <img :src="`${pagebase}/static/img/cst/consulting.png`" alt="" class="consultingIcon" @click="arrangeShow">
    <div class="footerMod">
      <div class="signUp">
        <div class="signUpPrice" v-if="type">
          <p class="originalCost">在校大学生特惠价：<span>{{activityCon.cash_origin_price}}</span></p>
          <p class="currentPrice">早鸟价：<span>{{activityCon.cash_price}}</span></p>
        </div>
        <div class="signUpPrice discounts" v-else>
          <p class="currentPrice">在校大学生特惠价：<span>{{activityCon.cash_price}}</span></p>
        </div>
        <div class="signUpBtn" @click="signUp">立即报名</div>
      </div>
    </div>
    
    <div class="consult_alert" v-bind:class="{'arrangeshow': arrangeshow}" @click="consultClose">
      <div class="consult_alert_con">
        <div class="consult_alert_ma">
          <p>保存识别二维码</p>
          <div v-html="this.activityCon.tips"></div>
          <!-- <p>发送“仿真”咨询入营</p> -->
          <img class="" :src="this.activityCon.qrcode" alt="">
        </div>
        <div class="consult_close_btn">
          <img class="" :src="`${pagebase}/static/img/si/close.png`" alt="">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {pagebase} from '@/utils/http.js';
  import utils from '@/utils/utils';
  import WxShare from '@/utils/wxshare';

  // 百度
  var _hmt = _hmt || [];
  (function() {
    var hm = document.createElement("script");
    hm.src = "https://hm.baidu.com/hm.js?24b8cea1e8cafdb512e2f597cf3fa8df";
    var s = document.getElementsByTagName("script")[0];
    s.parentNode.insertBefore(hm, s);
  })();

  export default {
    data() {
      return {
        aid: this.$route.query.aid || '',
        type: this.$route.query.type || 0,
        activityCon: {},
        arrangeshow: false,
        pagebase: pagebase,
      }
    },
    
    mounted(){
      this.init();
    },
    
    methods:{
      init(){
        // 微信分享
        this.wxshare = new WxShare();
        this.getactivityCon();
      },
      
      getactivityCon() {
        this.$http({
          url: '/activity/Info',
          method: 'get',
          params: {
            activity_id: this.aid,
          },
        }).then(res => {
          if (res.code >= 0) {
            let data = res.data;
            this.activityCon = data;
            document.title = data.title;
            this.wxshare.share({
              title: data.title,
              desc: data.summary,
              link: window.location.href,
              imgUrl: data.cover,
            })
          }
        })
      },
      
      arrangeShow() {
        this.arrangeshow = true;
      },
      
      consultClose() {
        this.arrangeshow = false;
      },
      
      signUp() {
        var succeedUrl = encodeURIComponent(pagebase + '/#/paySucceed?activity_id=' + this.aid);
        if (utils.browserChecker.isWx()) {
          var channel = this.$route.query.channel || '';
          var open = encodeURIComponent(pagebase + '/#/payment?activity_id=' + this.aid + '&project=emc' + '&channel=' + channel + '&succeed_url=' + succeedUrl);
          var url = 'http://edu.eda365.com/wechat_redirect.php?jump_url=' + open;
          window.location.href = url;
        } else {
          this.$router.push({
            path: '/payment',
            query: {
              activity_id: this.aid,
              channel: this.$route.query.channel || '',
              project: 'emc',
              track_id: this.$route.query.track_id || '',
              succeed_url: succeedUrl,
            }
          })
        }
      },
    }
  }
</script>

<style lang="css" scoped>
  .cst {
    background-color: #1E2C33;
    padding-bottom: 8rem;
  }

  .banner {
    width: 100%;
  }

  .modImg {
    width: 100%;
  }
  
  .footerMod {
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 8rem;
    background: linear-gradient(to bottom, rgba(30, 97, 105, 0.8), rgba(15, 76, 82, 1));
    z-index: 10;
  }
  
  .consultingIcon {
    width: 7.2rem;
    height: 7.2rem;
    position: fixed;
    right: 1rem;
    bottom: 8.5rem;
    z-index: 10;
  }
  
  .signUp {
    height: 5rem;
    display: flex;
    justify-content: space-between;
    background-color: rgba(13, 43, 72, 0.01);
    box-sizing: border-box;
    padding: 0 1.5rem;
    margin-top: 1rem;
  }
  
  .signUpPrice {
    height: 2rem;
    align-items: flex-end;
  }
  
  .discounts {
    margin-top: 1rem;
  }
  
  .originalCost {
    font-size: 1.5rem;
    color: #E2993C;
    margin-right: 1rem;
  }
  
  .currentPrice {
    font-size: 1.6rem;
    color: #FFFFFF;
  }
  
  .currentPrice span {
    font-size: 2rem;
    color: #FFB75C;
  }
  
  .signUpBtn {
    width: 10rem;
    height: 3rem;
    line-height: 3rem;
    border-radius: 3rem;
    background-color: #F7443F;
    text-align: center;
    font-size: 1.6rem;
    color: #FFFFFF;
    margin-top: .7rem;
    box-shadow: .1rem .3rem .5rem rgba(0, 0, 0, 0.3)
  }
  
  .consult_alert {
    display: none;
    z-index: 11;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.8);
  }
  
  .consult_alert_con {
    position: absolute;
    top: 50%;
    left: 50%;
    margin-top: -14rem;
    margin-left: -14rem;
    width: 28rem;
    height: 28rem;
    background-color: #F3F7FC;
    border-radius: 1rem;
  }
  
  .consult_alert_ma {
    height: 100%;
    display: flex;
    font-size: 1.8rem;
    font-weight: 600;
    color: #080943;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  
  .consult_alert_ma img {
    width: 15rem;
    height: 15rem;
  }
  
  .arrangeshow {
    display: block;
  }
  
  .consult_close_btn {
    margin-top: .5rem;
    display: flex;
    justify-content: center;
  }
  
  .consult_close_btn img {
    width: 3.8rem;
    height: 3.8rem;
  }
  
  @media (min-width: 750px) {
    .consultingIcon{
      right: 50%;
      margin-right: -375px;
    }
    
    .footerMod {
      width: 750px;
      left: 50%;
      margin-left: -375px;
    }
  }
</style>
